import React from "react";
import Hello from "../components/Hello";
import Planets from "../components/Planets";
import NavBar from "../components/NavBar";
import "./App.css";
import facebookPng from "/facebook.png";
import linkedinLogoPng from "/linkedinLogo.png";
import instagramPng from "/instagram.png";
import youtubePng from "/youtube.png";

export default function App({ children }: { children?: React.ReactNode }) {
	return (
		<>
			<Hello />

			<section>
				<div>
					<Planets />
				</div>
			</section>

			<NavBar />

			{children}

			{/* Info Section */}
			<section className="InfoSection">
				<div className="info-left">
					<h2>Join Us As We Help Others!</h2>
				</div>

				<div className="info-middle">
					<ul className="info-list">
						<li>
							<i className="fa fa-map-marker" aria-hidden="true"></i>
							<span>560 55th St, West New York, NJ 07093</span>
						</li>
						<li>
							<i className="fa fa-phone" aria-hidden="true"></i>
							<span>Call 201-417-7488</span>
						</li>
						<li>
							<i className="fa fa-envelope" aria-hidden="true"></i>
							<span>wally@iwanciw.com</span>
						</li>
					</ul>

					<div className="info_social">
						<a href="https://www.youtube.com/@UncleWally-p4l">
							<img width={32} height={32} src={youtubePng} alt="Youtube" />
						</a>
						<a href="https://www.facebook.com/IWANCIW.FF">
							<img width={32} height={32} src={facebookPng} alt="Facebook" />
						</a>
						<a href="https://www.linkedin.com/company/iwanciw-functional-funware/">
							<img width={32} height={32} src={linkedinLogoPng} alt="LinkedIn" />
						</a>
						<a href="https://instagram.com/iwanciwfunware">
							<img width={32} height={32} src={instagramPng} alt="Instagram" />
						</a>
					</div>
				</div>

				<div className="info-right">
					<h1>Let's Spread The Good News!</h1>
				</div>
			</section>

			<footer className="footer">
				<p className="text-footer">
					Copyright © 2024 All Rights Reserved. Design by UNCLE WALLY'S WORLD
				</p>
			</footer>
		</>
	);
}
